export default __webpack_public_path__ + "static/Benifit_3-05953cbbfcfa20213fef6295499de59d.svg";